import ExploreGrid from "../../components/ExploreGrid/ExploreGrid";
import Header from "../../components/Header/Header";
import Footer from '../Home/Footer';

export default function FindAMentor() {
  return (
    <>
      <Header />
      <ExploreGrid />
      <Footer/>
    </>
  );
}
